export async function initializeCard(payments, cardElementId = '#card-container') {
	const card = await payments.card();
	await card.attach(cardElementId);

	return card;
}

export async function tokenize(paymentMethod) {
	return await paymentMethod.tokenize();
}

/* E.g. verificationDetails
https://github.com/square/web-payments-quickstart/blob/main/public/examples/card-payment-with-verification.html

const verificationDetails = {
		amount: '1.00',
		billingContact: {
			addressLines: ['123 Main Street', 'Apartment 1'],
			familyName: 'Doe',
			givenName: 'John',
			email: 'jondoe@gmail.com',
			country: 'GB',
			phone: '3214563987',
			region: 'LND',
			city: 'London'
		},
		currencyCode: 'GBP',
		intent: 'CHARGE'
	};
*/
export async function verifyBuyer({ verificationDetails, payments, token }) {
	const verificationResults = await payments.verifyBuyer(token, verificationDetails);
	return verificationResults.token;
}
